import React from 'react';
import { LandingPageConfig } from 'src/generated/landing-page-config-schemas/v1/type';
import { Box, Typography, Button, useTheme } from '@mui/material';
import { useRouter } from 'next/router';
import useAnalytics from 'src/analytics/useAnalytics';

type Props = Extract<
  LandingPageConfig['data']['slices'][number],
  { type: 'call-to-action-banner' }
>;

const CallToActionBanner: React.FC<Props> = (props) => {
  const theme = useTheme();
  const { title, subtitle, ctaButton } = props;
  const router = useRouter();
  const { track } = useAnalytics();

  /*
    Preserve all query params from the landing page when redirecting to the menu page.
  */
  const handleMenuRedirect = () => {
    track('Landing Page CTA Clicked', { cta_location: 'cta-banner' });
    router.push({ pathname: '/menu', query: router.query });
  };
  return (
    <Box
      sx={{
        backgroundColor: theme.palette.primary.main,
        py: { xs: 8, md: 10 },
        px: { xs: 4, md: 2 },
      }}
    >
      <Box
        sx={{
          maxWidth: '1312px',
          margin: '0 auto',
          px: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: { xs: 'left', md: 'center' },
        }}
      >
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: '32px', md: '48px' },
            fontWeight: 600,
            color: theme.palette.primary.contrastText,
            mb: 2,
            width: '100%',
          }}
        >
          {title}
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: '18px', md: '24px' },
            color: theme.palette.primary.contrastText,
            maxWidth: '650px',
            mb: 4,
            width: '100%',
            whiteSpace: 'pre-line',
          }}
        >
          {subtitle}
        </Typography>

        <Button
          variant={'contained'}
          onClick={handleMenuRedirect}
          sx={{
            backgroundColor: theme.palette.primary.contrastText,
            color: theme.palette.primary.main,
            fontSize: '16px',
            fontWeight: 600,
            px: 4,
            py: 1.5,
            borderRadius: '50px',
            textTransform: 'none',
            width: { xs: '100%', sm: 'auto' },
          }}
        >
          {ctaButton.label}
        </Button>
      </Box>
    </Box>
  );
};

export default CallToActionBanner;
